import React from 'react';
import { string, shape } from 'prop-types';
import styles from './styles/styles.module.scss';
import UserActionCardBase from '../UserActionCardBase';
import InviteButton from '../../../buttons/InviteButton';

const UserActionInviteCard = ({ name, userLink, profileImageUrl, subText, actions }) => {
  return (
    <UserActionCardBase
      name={name}
      userLink={userLink}
      profileImageUrl={profileImageUrl}
      subText={subText}
      button={<InviteButton text={actions.invite.title} href={actions.invite.href} className={styles.inviteButton} />}
      className={styles.inviteContainer}
    />
  );
};

UserActionInviteCard.propTypes = {
  name: string.isRequired,
  userLink: string.isRequired,
  profileImageUrl: string,
  subText: string,
  actions: shape({
    invite: shape({
      href: string,
      title: string
    })
  }).isRequired
};

UserActionInviteCard.defaultProps = {
  profileImageUrl: null,
  subText: ''
};

export default UserActionInviteCard;
